import { defaultHelpMeNowQuestion, defaultProactiveSuggestionInterval, type TimelineFeatures } from "@expert/features";

export const features: TimelineFeatures = {
    helpMeNowQuestion: defaultHelpMeNowQuestion,
    isGuidedFlowRecommendationEnabled: false,
    isHelpMeNowEnabled: false,
    isOzmoIFrameEnabled: false,
    isProactiveEnabled: false,
    isReactiveCallContextV2Enabled: false,
    isSalesFAQEnabled: false,
    proactiveSuggestionInterval: defaultProactiveSuggestionInterval,
};
